import { cn } from "@/utils/cn";

interface SectionLabelProps {
  children: React.ReactNode;
  /** Trailing slot — e.g. the "Add company" action on the companies section. */
  action?: React.ReactNode;
  className?: string;
}

/** The drawer's one and only section eyebrow. */
export const SectionLabel = ({
  children,
  action,
  className,
}: SectionLabelProps) => (
  <div
    className={cn(
      "flex min-h-6 items-center justify-between gap-2.5 px-1",
      className,
    )}
  >
    <h3 className="shrink-0 text-[11px] font-semibold tracking-[0.08em] text-muted-foreground uppercase">
      {children}
    </h3>
    {action}
  </div>
);
